export const ADD_TO_BAG = "ADD_TO_BAG";
export const ADD_TO_BAG_ERROR = "ADD_TO_BAG_ERROR";
export const RESET_BUTTON = "RESET_BUTTON";
import sdkProvider from "../../helpers/sdk-provider";

export function addSubscription() {
  return {
    type: ADD_TO_BAG,
  };
}

export function addSubscriptionError(error) {
  return {
    type: ADD_TO_BAG_ERROR,
    error,
  };
}

export function resetSubscriptionButton() {
  return {
    type: RESET_BUTTON,
  };
}

export function addPremierSubscription(subscriptionID) {
  return (dispatch) =>
    sdkProvider("bag").then((bag) => {
      return bag
        .addSubscription(subscriptionID)
        .then((data) => {
          dispatch(addSubscription(data));
        })
        .catch((error) => {
          let errorMessage = error.message;
          if (error.message === "") {
            errorMessage = "Service Error";
          }
          dispatch(addSubscriptionError(errorMessage));
        });
    });
}
